export const resolveMessageComposeUnavailableReason = (context) => {
  if (!context || context.loading || context.canCompose) return null;
  if (context.applicantIdentityConflict || context.applicant_identity_conflict) {
    return 'participant';
  }
  if (!(context.caseId || context.case_id)) return 'case';
  if (!(context.assignedStaffProfileId || context.assigned_staff_profile_id)) {
    return 'assignee';
  }
  if (!(context.assignedToUserId || context.assigned_to_user_id)) return 'staff_mapping';
  return 'context';
};
